<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Configurão salva </v-card-title>
        <v-card-text>
          Deseja finalizar a configuração ou continuar para uma outra operadora?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="onFinalizar"> Finalizar </v-btn>
          <v-btn text @click="onContinuar"> Continuar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    show() {
      this.dialog = true;
    },

    onFinalizar() {
      this.$emit('select', 'finalizar');
      this.dialog = false;
    },
    
    onContinuar() {
      this.$emit('select', 'continuar');
      this.dialog = false;
    },
  },
};
</script>